var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVestLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4391 4.62274H18.1976L18.1976 10.516H16.5831L18.8169 14.3975L21.0507 10.516L19.4391 10.516L19.4391 4.62274Z",
    fill: "#02B27F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.80335 4.62274L4.56189 4.62274L4.56189 10.516H2.9474L5.18118 14.3975L7.41496 10.516L5.80335 10.516L5.80335 4.62274Z",
    fill: "#02B27F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.099 6.54478L11.1666 6.54478L11.1666 14.6574L9.05745 14.6574L12.1321 20.0001L15.2067 14.6574L13.099 14.6574V6.54478Z",
    fill: "#F2AE00"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVestLight);
export default __webpack_public_path__ + "static/media/vestLight.96dfc8c3c99d78ae45cfedfd462b5c46.svg";
export { ForwardRef as ReactComponent };